<template>
  <div class="mk-subject-bottom">
    <div class="mk-subject-bottom-left">
      <img v-if="childItem.propsValue.data.customField1" :src="childItem.propsValue.data.customField1" alt />
      <span v-if="childItem.propsValue.data.customField2">{{ childItem.propsValue.data.customField2 }}</span>
      <p v-if="childItem.propsValue.data.customField3">{{ childItem.propsValue.data.customField3 }}</p>
      <p v-if="childItem.propsValue.data.customField4">T：{{ childItem.propsValue.data.customField4 }}</p>
      <p v-if="childItem.propsValue.data.customField5">F：{{ childItem.propsValue.data.customField5 }}</p>
      <p v-if="childItem.propsValue.data.customField6">E：{{ childItem.propsValue.data.customField6 }}</p>
    </div>
    <div class="mk-subject-bottom-right">
      <img v-if="childItem.propsValue.data.customField7" :src="childItem.propsValue.data.customField7" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "MkFooterWeb",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 80,
          height: 55
        },
        {
          code: "customField2",
          label: "名称",
          type: "text"
        },
        {
          code: "customField3",
          label: "地址",
          type: "text"
        },
        {
          code: "customField4",
          label: "电话",
          type: "text"
        },
        {
          code: "customField5",
          label: "传真",
          type: "text"
        },
        {
          code: "customField6",
          label: "邮箱",
          type: "text"
        },
        {
          code: "customField7",
          label: "图片",
          type: "image",
          width: 630,
          height: 268
        }
      ],
      data: {
        customField1:
          "https://mks.yybip.com/group1/M00/01/80/CgoRDGO805-ATNWLAAAUJJkqIE8904.png",
        customField2: "",
        customField3: "",
        customField4: "",
        customField5: "",
        customField6: "",
        customField7:
          "https://mks.yybip.com/620x/group1/M00/02/CA/CgoRC16OvwmAe8jjAOiKja482YQ770.jpg"
      }
    };
  }
};
</script>


<style lang="scss" scoped>
.mk-subject-bottom {
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  min-height: 262px;
  background: #242424;
  color: #ffffff;
  padding: 20px 5%;
  display: flex;
  .mk-subject-bottom-left {
    width: 50%;
    img {
      max-width: 80px;
      width: auto;
      height: auto;
    }

    span {
      font-size: 20px;
      display: block;
      margin-top: 16px;
      margin-bottom: 16px;
      color: #ffffff;
    }

    p {
      font-size: 14px;
      margin-top: 8px;
      color: #ffffff;
    }
  }

  .mk-subject-bottom-right {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 300px;
    }
  }
}
</style>
